<template>
    <div>
        <v-chart :key="symbol_code+':' + echartsTheme" :style="chart_style()" :options="line" :theme="echartsTheme" :notMerge="true" :autoresize="true" @click="handleChartClick" />
    </div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
    import { calculateBuySignals, movingAverage } from '../../utils/strategy2560'
	import {
		request_zzquant
	} from "network/request.js"

    
	
	const dataZoomData = {
		"start": 60,
		"end": 100
	}

	export default {
		props: {
			title: String,
			subText: String,
			symbol_code: String,
			zoom_start:{type:Number,default:60},
			chart_heigh:{type:String,default:'600px'},
			chart_width:{type:String,default:'100%'},
			highlightDate: String,
            showLhb: { type: Boolean, default: false },
            traderName: { type: String, default: '' },
            kline_url: { type: String, default: '' },
		},
	components: {
		'v-chart': ECharts
	},
		watch:{
			symbol_code:'refresh',
			highlightDate: 'updateHighlight',
            traderName: 'refresh'
		},
data() {
    return {
        theme:'light',
        colorblind: false,
        internalHighlightDate: null,
        lhbData: [],
        cancelTokenSource: null,
        line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: '1%',
						// textAlign:'right',
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					legend: {
						type: 'scroll',
						show: true,
						top: 8,
						left: 80,
						right: 12,
						itemWidth: 10,
						itemHeight: 7,
						itemGap: 6,
						textStyle: {
							color: '#999999',
							fontSize: 10,
							padding: [0, 0, 0, -2]
						},
						pageButtonPosition: 'end',
						pageIconSize: 8,
						pageTextStyle: {
							color: '#999999',
							fontSize: 9
						},
						data: ['K', 'MA5', 'VOL', '榜买', '榜卖'],
						selected: {
							'MA5': true,
							'MA25': true,
							'K': true,
							'VOL': true,
							'Volume': true,
							'v5': true,
							'v60': true,
							'收盘价': true,
							'收盘': true,
							'最新价': true,
							'今板': true,
							'明板': true,
							'today_uplimit': true,
							'next_uplimit': true,
							'冲量': true,
							'冲量回踩': true,
							'金叉': true,
							'金叉起动': true,
							'共振': true,
							'共振确认': true,
							'B1': true,
							'B2': true,
							'B3': true,
							'榜买': true,
							'榜卖': true,
							'LHB Buy': true,
							'LHB Sell': true
						}
					},
					visualMap: {
						show: false,
						seriesIndex: 3,
						dimension: 2,
						pieces: [{
							value: 1,
							color: '#0072B2'
						}, {
							value: -1,
							color: '#E69F00'
						}]
					},
					grid: [{
							left: '10%',
							right: '8%',
							height: '50%'
						},
						{
							left: '10%',
							right: '8%',
							top: '63%',
							height: '25%'
						}
					],
					xAxis: [{
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisLabel: {
								show: false
							},
							splitNumber: 20,
							min: 'dataMin',
							max: 'dataMax'
						}
					],
					yAxis: [{
							scale: true,
							offset: 2,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							position: 'left',
							min: 'dataMin',
							max: 'dataMax',
						},
						{
							scale: true,
							offset: 2,
							position: 'right',
							gridIndex: 1,
							splitNumber: 2,
							axisLabel: {
								show: false
							},
							axisLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							splitLine: {
								show: false
							},
						}, {
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							// axisLine: {
							// 	lineStyle: {
							// 		color: '#666666',
							// 		width: 1
							// 	}
							// },
							splitLine: false,
							position: 'right',

						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: dataZoomData.end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},
	computed:{
		echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null }
	},
mounted() {
	// console.log("mounted");
	this.refresh();
	{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }
	{ const c = localStorage.getItem('site.colorblind'); if(c){ this.colorblind = (c==='1' || c==='true') } }
	window.addEventListener('site-theme-changed', this.onThemeChanged)
	window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
	window.addEventListener('keydown', this.onKeydown)
},
		beforeDestroy(){ window.removeEventListener('site-theme-changed', this.onThemeChanged); window.removeEventListener('site-colorblind-changed', this.onColorblindChanged); window.removeEventListener('keydown', this.onKeydown) },
		created(){
			this.onThemeChanged = (e)=>{ const t = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = t }
			this.onColorblindChanged = (e)=>{ const v = e && e.detail && typeof e.detail.colorblind!=='undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() }
			this.onKeydown = (e)=>{ const k = e && e.key ? e.key : ''; if(k==='ArrowLeft' || k==='Left'){ e.preventDefault && e.preventDefault(); this.moveHighlight(-1) } else if(k==='ArrowRight' || k==='Right'){ e.preventDefault && e.preventDefault(); this.moveHighlight(1) } }
		},
		methods: {
			chart_style(){
				return {
					width: this.chart_width,
					height: this.chart_heigh,
				}
			},
            calculateMA(dayCount, data) {
                const study = data.buyStudy;
                const values = study && (dayCount === 5 || dayCount === 25)
                    ? study[dayCount === 5 ? 'ma5' : 'ma25']
                    : movingAverage(data.values.map(row => Number(row[1])), dayCount);
                // Draw adjusted averages in each candle's raw-price coordinates.
                return values.map((value, index) => value === null || !Number.isFinite(value) ? '-'
                    : study && (dayCount === 5 || dayCount === 25) ? value / study.factors[index] : value);
            },
            calculateVolumeMA(dayCount, data) {
                return movingAverage(data.vols.map(row => Number(row[1])), dayCount)
                    .map(value => value === null ? '-' : value);
            },
            refresh(date) {
                // Cancel previous request
                if (this.cancelTokenSource) {
                    this.cancelTokenSource.cancel('Operation canceled by the user.');
                }
                this.cancelTokenSource = axios.CancelToken.source();

                this.resetChart();
                this.line['title']  = {
                    text: this.title,
                    subtext: this.subText,
                    // left: 0
					textStyle: {
						color: '#999999'
					},
					subtextStyle: {
						color: '#666666'
					}
                };
                if(this.symbol_code && this.symbol_code.length!=6){
                    return
                }
                const effDate = this.internalHighlightDate || this.highlightDate;
                date = effDate ? effDate : date;
                if (!this.symbol_code){
                    return
                }
                const reqUrl = this.kline_url ? this.kline_url : ('/v3/open/kline/d/' + this.symbol_code);
				axios.all([
                        request_zzquant({
                            'url': reqUrl,
                            cancelToken: this.cancelTokenSource.token
                        }),
                        this.showLhb ? request_zzquant({
                            'url': '/v3/market/lhb/stock/history',
                            'method': 'get',
                            'params': {
                                'stock_code': this.symbol_code,
                                'trader_name': this.traderName
                            },
                            cancelToken: this.cancelTokenSource.token
                        }) : Promise.resolve({ data: { code: 0, data: [] } })
					])
			.then(axios.spread((resp1, resp2) => {
						// console.log(resp1);
						// console.log(resp2);
						let splitDataItem = this.splitData(resp1['data']['data'], date);
                        const buyStudy = calculateBuySignals(splitDataItem);
                        splitDataItem.buyStudy = buyStudy;
                        let lhbList = (resp2 && resp2['data'] && (resp2['data']['code'] === 0 || resp2['data']['code'] === 20000)) ? resp2['data']['data'] : [];
                        this.lhbData = lhbList;

						// 更新title
						// let symbol_name = resp1['data']['data']['name'];
						this.line['title']  = {
							text: this.title,
							// subtext: symbol_name,
							textStyle: {
								color: '#999999'
							},
							subtextStyle: {
								color: '#666666'
							}
						};
					let series_data = []
					const upColor = this.colorblind ? '#E69F00' : '#ec0000'
					const downColor = this.colorblind ? '#0072B2' : '#00da3c'
						series_data.push({
							name: 'MA5',
							data: this.calculateMA(5, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								}
							},
							symbol: 'circle',
						});
						
						series_data.push({
							name: 'MA25',
							data: this.calculateMA(25, splitDataItem),
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
									color: '#9932CC' // 紫色
								}
							},
							symbol: 'circle',
						});

						series_data.push({
							name: 'K',
							data: splitDataItem.values,
							type: 'candlestick',
							itemStyle: {
								normal: {
								color: upColor,
								color0: downColor,
								borderColor: upColor,
								borderColor0: downColor,
								borderWidth: 1.5
							}
						},

						});

						series_data.push({
							name: 'VOL',
							data: splitDataItem.vols,
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
						});
						
						// 添加5日成交量均线
						series_data.push({
							name: 'v5',
							data: this.calculateVolumeMA(5, splitDataItem),
							type: 'line',
							xAxisIndex: 1,
							yAxisIndex: 1,
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: '#FF8C00' // 深橙色
								}
							},
						});
						
						// 添加60日成交量均线
						series_data.push({
							name: 'v60',
							data: this.calculateVolumeMA(60, splitDataItem),
							type: 'line',
							xAxisIndex: 1,
							yAxisIndex: 1,
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.8,
									color: '#4169E1' // 皇家蓝
								}
							},
						});

						// 基准收盘价（或最后一日最新价）
						series_data.push({
							name: '收盘价',
							data: splitDataItem.values_close_last,
							type: 'line',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.6,
								color: upColor
							},
						},
							symbol: 'circle',
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
									type: 'max',
									name: '收盘价',
									symbol: 'circle',
								}, ]
							}
						});

                        // 次日涨停位
                        series_data.push({
                            name: '明板',
                            data: splitDataItem.values_next_uplimit,
                            type: 'line',
                            showSymbol: false,
                            lineStyle: {
                                normal: {
                                    width: 1,
                                    opacity: 0.4,
                                    color: 'gray'
                                },
                            },
                            symbol: 'circle',
                            markLine: {
                                symbol:'none',//去掉箭头
                                data: [{
                                    type: 'max',
                                    name: '次日涨停',
                                    symbol: 'circle',
                                }, ]
                            }
                        });
						
						// 添加LHB标记
                        if (this.showLhb && this.lhbData && this.lhbData.length > 0) {
                            let lhbBuyData = [];
                            let lhbSellData = [];
                            
                            // Map LHB data by date for faster lookup
                            const lhbMap = {};
                            this.lhbData.forEach(item => {
                                // API returns date as 'YYYY-MM-DD'
                                // K-line categoryData is 'YYYYMMDD'
                                const dateKey = item.date.replace(/-/g, '');
                                lhbMap[dateKey] = item;
                            });

                            for (let i = 0; i < splitDataItem.categoryData.length; i++) {
                                const dateKey = splitDataItem.categoryData[i];
                                const lhbItem = lhbMap[dateKey];
                                
                                if (lhbItem) {
                                    // B point: Buy > 0
                                    if (lhbItem.buy_in > 0) {
                                        lhbBuyData.push([
                                            dateKey,
                                            this.computeMarkerY(splitDataItem, i)
                                        ]);
                                    } 
                                    // S point: Buy < 0 (Net Sell)
                                    else if (lhbItem.buy_in < 0) {
                                        lhbSellData.push([
                                            dateKey,
                                            this.computeMarkerY(splitDataItem, i)
                                        ]);
                                    }
                                }
                            }

                            if (lhbBuyData.length > 0) {
                                series_data.push({
                                    name: '榜买',
                                    type: 'scatter',
                                    data: lhbBuyData,
                                    symbol: 'circle', // Using circle for cleaner look, or 'arrow'
                                    symbolSize: 12,
                                    symbolOffset: [0, -10],
                                    itemStyle: {
                                        color: '#d9534f' // Bootstrap danger red
                                    },
                                    label: {
                                        show: true,
                                        formatter: this.traderName ? 'B' : '榜',
                                        color: '#fff',
                                        fontSize: 8,
                                        position: 'inside'
                                    },
                                    z: 100
                                });
                            }

                            if (lhbSellData.length > 0) {
                                series_data.push({
                                    name: '榜卖',
                                    type: 'scatter',
                                    data: lhbSellData,
                                    symbol: 'circle',
                                    symbolSize: 12,
                                    symbolOffset: [0, -10],
                                    itemStyle: {
                                        color: '#28a745' // Bootstrap success green
                                    },
                                    label: {
                                        show: true,
                                        formatter: this.traderName ? 'S' : '榜',
                                        color: '#fff',
                                        fontSize: 8,
                                        position: 'inside'
                                    },
                                    z: 100
                                });
                            }
                        }

                        // Reuse buy-only rules from the complete loaded history.
                        const buyTypes = [
                            ['surge', '冲量', 'path://M0,-10 L2.94,-4.05 L9.51,-3.09 L4.76,1.55 L5.88,8.09 L0,5 L-5.88,8.09 L-4.76,1.55 L-9.51,-3.09 L-2.94,-4.05 Z'],
                            ['golden', '金叉', 'arrow'],
                            ['resonance', '共振', 'circle'],
                            ['B1', 'B1', 'arrow'],
                            ['B2', 'B2', 'diamond'],
                            ['B3', 'B3', 'triangle']
                        ];
                        const markerColor = this.colorblind ? upColor :
                            window.getComputedStyle(document.documentElement).getPropertyValue('--accent-color').trim() || upColor;
                        const markerOffsets = {
                            surge: [0, -18], golden: [-10, -18], resonance: [10, -18],
                            B1: [-10, -6], B2: [0, -6], B3: [10, -6]
                        };
                        buyTypes.forEach(([key, name, symbol]) => {
                            const points = [];
                            buyStudy.signals[key].forEach((active, index) => {
                                if (active) points.push([
                                    splitDataItem.categoryData[index],
                                    this.computeMarkerY(splitDataItem, index)
                                ]);
                            });
                            series_data.push({
                                name, type: 'scatter', data: points, symbol,
                                symbolSize: 7, symbolOffset: markerOffsets[key],
                                itemStyle: { color: markerColor },
                                label: { show: false }, z: 10
                            });
                        });
                        // Include empty types so users can consistently toggle comparisons.
                        this.line.legend.data = series_data.map(series => series.name);

                        const eff = this.internalHighlightDate || this.highlightDate;
                        if (eff) {
                            let xHighLightDate = eff.replaceAll("-", "")
                            let highlightIndex = splitDataItem.categoryData.indexOf(xHighLightDate);
                            // console.log(xHighLightDate)
                            if (highlightIndex !== -1) {
							let highlightSeriesMarkLine = {
								name: 'Highlight MarkLine',
								type: 'line',
								markLine: {
									silent: true,
									data: [{
										name: 'highlight line',
										xAxis: xHighLightDate,
										lineStyle: {
											normal: {
												width: 2,
												opacity: 0.6,
												color: 'rgba(135, 206, 235)'
											},
										}
									}]
								}
							};
							series_data.push(highlightSeriesMarkLine);
							
							// Create a new series for the highlight point on the Volume chart
							let highlightSeriesVolume = {
								name: 'Highlight Volume',
								type: 'scatter',
								symbol: 'pin',
								symbolSize: 15,
								xAxisIndex: 1,
								yAxisIndex: 1,
								data: [
									[xHighLightDate, splitDataItem.vols[highlightIndex][1]]
								] // Use the volume for the y value
							};
							series_data.push(highlightSeriesVolume);

							const totalPoints = splitDataItem.categoryData.length;
							if (totalPoints > 0) {
								let startIdx = highlightIndex;
								let endIdx = highlightIndex;
								if (highlightIndex > 0 && highlightIndex < totalPoints - 1) {
									startIdx = highlightIndex - 1;
									endIdx = highlightIndex + 1;
								} else if (highlightIndex === 0 && totalPoints > 1) {
									startIdx = highlightIndex;
									endIdx = highlightIndex + 1;
								} else if (highlightIndex === totalPoints - 1 && totalPoints > 1) {
									startIdx = highlightIndex - 1;
									endIdx = highlightIndex;
								}
								const startDate = splitDataItem.categoryData[startIdx];
								const endDate = splitDataItem.categoryData[endIdx];
								const areaData = [[{ xAxis: startDate }, { xAxis: endDate }]];
								const areaStyle = { color: 'rgba(135, 206, 235, 0.15)' };
								const kSeries = series_data.find(s => s.name === 'K' && s.type === 'candlestick');
								if (kSeries) {
									kSeries.markArea = { silent: true, itemStyle: areaStyle, data: areaData };
								}
								const volSeries = series_data.find(s => (s.name === 'VOL' || s.name === 'Volume') && s.type === 'bar');
								if (volSeries) {
									volSeries.markArea = { silent: true, itemStyle: areaStyle, data: areaData };
								}
							}

							const dz = Array.isArray(this.line.dataZoom) ? this.line.dataZoom[0] : null;
							if (dz && typeof dz.start === 'number' && typeof dz.end === 'number') {
								const total = splitDataItem.categoryData.length;
								const datePct = total > 0 ? (highlightIndex / total) * 100 : 0;
								const currStart = dz.start;
								const currEnd = dz.end;
								const inView = datePct >= currStart && datePct <= currEnd;
								if (!inView) {
									const range = currEnd - currStart;
									let newStart = datePct - range * 0.3;
									if (newStart < 0) newStart = 0;
									if (newStart + range > 100) newStart = 100 - range;
									dz.start = Math.max(0, Math.min(100, newStart));
									dz.end = Math.max(0, Math.min(100, dz.start + range));
								}
							}
						}
					}
						
						
                        if (Array.isArray(this.line.xAxis) && this.line.xAxis.length >= 2) {
                            this.line.xAxis[0].data = splitDataItem.categoryData
                            this.line.xAxis[1].data = splitDataItem.categoryData
                        }
                        this._klineSplit = splitDataItem
                        this.line.tooltip.formatter = (params) => {
                            const p = Array.isArray(params) ? params[0] : params
                            const dateRaw = (p && (p.name || p.axisValue)) || ''
                            const idx = this._klineSplit ? this._klineSplit.categoryData.indexOf(String(dateRaw)) : -1
                            const dateStr = dateRaw.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
                            const wkMap = ['周日','周一','周二','周三','周四','周五','周六']
                            const wk = dateStr ? wkMap[new Date(dateStr).getDay()] : ''
                            const yv = this._klineSplit && this._klineSplit.values && this._klineSplit.values[idx] ? this._klineSplit.values[idx] : null
                            if (!yv) return dateStr
                            const open = yv[0]
                            const close = yv[1]
                            const low = yv[2]
                            const high = yv[3]
                            const preclose = this._klineSplit.values_preclose && this._klineSplit.values_preclose[idx]
                            const volume = (this._klineSplit.vols && this._klineSplit.vols[idx] && this._klineSplit.vols[idx][1]) || ''
                            const turnover = this._klineSplit.values_turnover && this._klineSplit.values_turnover[idx]
                            const turnoverPct = (turnover !== undefined && turnover !== '-') 
                                ? (Number(turnover) / 100).toFixed(2) 
                                : ''
                            const openPct = preclose ? (((open - preclose) / preclose) * 100).toFixed(2) : ''
                            const closePct = preclose ? (((close - preclose) / preclose) * 100).toFixed(2) : ''
                            const amplitudePct = preclose ? (((high - low) / preclose) * 100).toFixed(2) : ''
                            const volText = typeof volume === 'number' ? volume.toLocaleString() : volume
                            const openSign = preclose && open - preclose >= 0 ? '+' : ''
                            const closeSign = preclose && close - preclose >= 0 ? '+' : ''
                            return [
                                `${dateStr} ${wk}`,
                                `涨幅: ${closePct ? (closeSign + closePct + '%') : '-'}`,
                                `开盘: ${openPct ? (openSign + openPct + '%') : '-'}`,
                                `振幅: ${amplitudePct ? (amplitudePct + '%') : '-'}`,
                                `换手: ${turnoverPct !== '' ? (turnoverPct + '%') : '-'}`,
                                `开盘价: ${open}`,
                                `收盘价: ${close}`,
                                `最高价: ${high}`,
                                `最低价: ${low}`,
                                `成交量: ${volText}`
                            ].join('<br/>')
                        }
					this.line['series'] = series_data
					if (this.line && this.line.visualMap && Array.isArray(this.line.visualMap.pieces)) {
						this.line.visualMap.pieces[0].color = downColor
						this.line.visualMap.pieces[1].color = upColor
					}
			}))
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled', err.message);
                } else {
                    console.log(err);
                }
            })
        },
        resetChart(){
            this.line['series'] = []
        },
			splitData(rawData, targetDate) {
				let[categoryData, values, values_close, vols, values_close_last, values_next_uplimit, values_preclose, values_turnover] = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]]
				let [x,y,vol] = [rawData['x'],rawData['y'],rawData['vol']]
				let turnover = rawData['turnover'] || []
				let idx_start = 0;
				let idx_end = x.length

				// 动态确定基准日期索引：若指定标记日期且存在，则取该日；否则取最后一日
				const eff = targetDate || this.internalHighlightDate || this.highlightDate;
				let targetIdx = -1;
				if (eff) {
					const cleanDate = String(eff).replace(/-/g, '');
					targetIdx = x.indexOf(cleanDate);
				}
				if (targetIdx === -1 || targetIdx >= y.length) {
					targetIdx = y.length - 1;
				}

				const baseClose = (targetIdx >= 0 && targetIdx < y.length && y[targetIdx]) ? Number(y[targetIdx][1]) : 0;
				const isSt = (Array.isArray(rawData.is_st) && rawData.is_st[targetIdx]) || false;
				let limitRatio = 0.10;
				if (isSt) {
					limitRatio = 0.05;
				} else if (this.symbol_code.startsWith('30') || this.symbol_code.startsWith('68')) {
					limitRatio = 0.20;
				} else if (this.symbol_code.startsWith('8') || this.symbol_code.startsWith('4') || this.symbol_code.startsWith('92')) {
					limitRatio = 0.30;
				}
				const nextUplimit = Number((baseClose * (1 + limitRatio)).toFixed(2));

				for (let i = idx_start; i < idx_end; i++) {
					categoryData.push(x[i]);
					values.push([y[i][0], y[i][1], y[i][3], y[i][2]]);
					values_close.push(y[i][1]);
					values_close_last.push(baseClose);
					values_turnover.push(turnover[i] != null ? turnover[i] : '-')
					values_preclose.push((y[i].length > 4 && y[i][4] != null) ? y[i][4] : (i > 0 ? y[i-1][1] : y[i][1]))
					values_next_uplimit.push(nextUplimit);
					vols.push([i, vol[i], y[i][0] > y[i][1] ? 1 : -1]);
				}
				return {
					categoryData: categoryData,
					values: values,
					values_close: values_close,
					values_close_last: values_close_last,
					values_next_uplimit: values_next_uplimit,
					values_preclose: values_preclose,
					values_turnover: values_turnover,
                    is_st: Array.isArray(rawData.is_st) ? rawData.is_st : null,
                    is_paused: Array.isArray(rawData.is_paused) ? rawData.is_paused : null,
					vols: vols,
				};
			},
            handleChartClick(params) {
                // 扩大点击响应区域，只要有日期信息就触发事件
                if (params.name) {
                    // 获取点击的日期
                    const clickedDate = params.name;
                    // 发送事件到父组件
                    this.$emit('date-selected', clickedDate);
                    this.internalHighlightDate = clickedDate;
                    this.refresh();
                }
            },
			computeMarkerY(data, index) {
				return data.values[index][3];
			},
			moveHighlight(delta){
				const data = this._klineSplit && this._klineSplit.categoryData ? this._klineSplit.categoryData : [];
				if(!data || data.length===0) return;
				const eff = this.internalHighlightDate || this.highlightDate || data[data.length-1];
				const effRaw = typeof eff==='string' ? eff.replace(/-/g,'') : '';
				let idx = data.indexOf(effRaw);
				if(idx===-1){ idx = delta<0 ? data.length-1 : 0 }
				let newIdx = idx + delta;
				if(newIdx < 0) newIdx = 0;
				if(newIdx > data.length-1) newIdx = data.length-1;
				this.internalHighlightDate = data[newIdx];
				this.$emit('date-selected', this.internalHighlightDate);
				this.refresh();
			},
            updateHighlight() {
                this.internalHighlightDate = this.highlightDate || null;
                this.refresh();
            },
			

		}
	}
</script>

<style>
.chart_stock_kline_popular {
	width: 100%;
	height: 600px;
}
</style>
